import styled from 'styled-components'
import { rgba } from 'polished'

const animation = {
  duration: '200ms',
  delay: '300ms'
}

export const Wrapper = styled.div<any>`
  .react-select {
    &__placeholder {
      color: ${props => props.theme.form.placeholderColor};
    }

    &__control {
      cursor: pointer;
      min-height: 40px;
      border-color: ${props => props.theme.form.passiveColor};
      border-radius: ${props => props.theme.form.borderRadius};
      transition:
        color ${animation.duration} ${animation.delay} linear,
        border-color ${animation.duration} ${animation.delay} linear,
        box-shadow ${animation.duration} ${animation.delay} linear;

      &--is-focused {
        box-shadow: ${props => props.theme.form.boxShadow};
      }

      &:hover {
        box-shadow: ${props => props.theme.form.boxShadow};
        border-color: ${props => props.theme.form.passiveColor};
      }

      ${props => props.hasError && `
        border: 1px solid ${props.theme.palette.state.danger} !important;
        &--is-focused {
          box-shadow: 0 0 7px ${rgba(props.theme.palette.state.danger, 0.6)} !important;
        }
      `}

      input {
        box-shadow: none !important;
      }
    }

    &__single-value {
      color: ${props => props.theme.form.fontColor};
    }

    &__indicator {
      svg {
        fill: ${props => props.theme.form.indicatorColor};
      }
    }

    &__indicator-separator {
      background-color: ${props => props.theme.form.passiveColor};
    }

    &__option {
      cursor: pointer;
      color: ${props => props.theme.form.fontColor};
      text-align: left;

      &--is-selected {
        color: ${props => props.theme.form.fontColor};
        background: ${props => props.theme.palette.general.greyLight};
      }

      &--is-focused {
        background: ${props => props.theme.palette.general.soft};
      }

      &--is-disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      &:active {
        background: ${props => props.theme.palette.general.greyLight};
      }
    }
  }
`

export const classNamePrefix = 'react-select'
